<template>
	<div class="choose" :class="{skin_2: skinIdx === 1}" v-cloak>
		<div class="choose_bg"></div>
		<div class="choose_img_wrap row_space_between">
			<!-- 换图片 -->
			<img :src="require(`@/assets/choose_${skinIdx + 1}_1.png`)" class="animated fadeInLeftBig" :class="`choose_img_${skinIdx + 1}_1`">
			<!-- 换图片 -->
			<img :src="require(`@/assets/choose_${skinIdx + 1}_2.png`)" class="animated fadeInRightBig" :class="`choose_img_${skinIdx + 1}_2`">
		</div>
		<!-- 换肤按钮 -->
		<div class="change_skin_btn animated fadeInDownBig" @click="changeSkin">
			<div class="change_skin_btn_inner">
				<!-- 换图片 -->
				<img :src="require(`@/assets/choose_${skinIdx + 1}_3.png`)" class="choose_img_1_3">
				<div class="change_skin_btn_txt">换<br/>肤</div>
			</div>
		</div>
		<div class="choose_main">
			<div class="choose_logo_wrap animated fadeInDownBig">
				<!-- 换图片 -->
				<img :src="require(`@/assets/logo_${skinIdx + 2}.png`)" class="logo_2">
				<div class="choose_logo_txt">
					<!-- 请选择版本 -->
					最新2022版效果更棒
				</div>
			</div>
			<div class="choose_btn_wrap row_space_between">
				<div target="blank" class="choose_btn animated fadeInLeftBig" @click="tip()">
					<div class="choose_btn_img_wrap">
						<img v-lazy="require(`@/assets/choose_1_4.png`)" class="choose_img_1_4">
					</div>
					<div class="choose_btn_txt yellow">2017版</div>
				</div>
				<div class="choose_btn animated fadeInRightBig" @click="$router.push('/index')">
					<div class="choose_btn_img_wrap">
						<img v-lazy="require(`@/assets/choose_1_5.png`)" class="choose_img_1_5">
					</div>
					<div class="choose_btn_txt green">2022版</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import db from "@/common/js/db.js";
	export default {
		name: 'choose',
		data() {
			return {
				skinIdx: 0,
				isResume: false
			}
		},
		destroyed() {
		},
		mounted() {
			this.isResume = db().type === 'resume'
			this.skinIdx = Math.floor(Math.random()*100) % 2 // 取0、1中任意一个值
		},
		methods: {
			changeSkin(){
				this.skinIdx = this.skinIdx === 1 ? 0 : 1
			},
			tip(){
				if(this.isResume) {
					// 已进入index页面，缓存了FUNLoaded，才能进2017版
					if(localStorage.getItem('FUNLoaded') === 'true'){
						window.open('https://lmyxywy.github.io/resume/#/')
					}else{
						this.$toast.info('看完2022版再回来看吧~')
					}
					
				}else{
					this.$toast.info('当前为博客版，不可查看哦')
				}
				
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../../common/less/index.less";

	.choose{
		border: @border_width solid #fff;
		height: calc(100vh - 2 * @border_width);
		overflow: hidden;
		position: relative;
		// transform: rotate(90deg);
	}
	@circle_size: 300vw;

	.choose_bg{
		background: @green;
		width: @circle_size;
		height: @circle_size;
		border-radius: 50%;
		margin-top: -266vw;
		margin-left: -102vw;
	}
	.choose_img_wrap{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
	}
	.choose_img_1_1{
		width: 18vw;
		height: 25vw;
	}
	.choose_img_1_2{
		width: 14vw;
		height: 18vw;
		margin-top: 12vw;
	}
	.change_skin_btn{
		position: absolute;
		top: 0;
		right: 15%;
		width: 50px;
		height: 100px;
		cursor: pointer;
		z-index: 5;
		transition: all 0.3s;

		&:hover{
			img{
				opacity: 0.7;
			}

		}
	}
	.choose_img_1_3{
		width: 50px;
		height: 100px;
		position: absolute;
		top: 0;
		left: 0;
		transition: all 0.3s;
	}
	.change_skin_btn_inner{
		position: relative;
	}
	.change_skin_btn_txt{
		position: absolute;
		color: @green;
		top: 0;
		left: 0;
		width: 50px;
		text-align: center;
		font-size: 22px;
		margin-top: 10px;
		font-weight: bold;
	}
	.choose_main{
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 2;
	}
	.choose_logo_wrap{
		text-align: center;
		margin-top: 90px;
	}
	.logo_2{
		width: 20vw;
		display: block;
		margin: 0 auto;
	}
	.choose_logo_txt{
		border-top: 2px solid rgba(255,255,255,0.8);
		display: inline-block;
		padding-top: 20px;
		margin-top: 20px;
		color: rgba(255,255,255,0.5);
		font-size: 30px;
	}
	.choose_btn_wrap{
		width: 46%;
		margin: 70px auto 0 auto;
	}

	@_yellow: #FCA733;
	@_green: #1CAAC4;

	.choose_btn{
		width: 18vw;
		border-radius: 30px;
		background: #fff;
		overflow: hidden;
		cursor: pointer;
		box-shadow: 0 0 15px 15px rgba(0,0,0,0.03);

		img{
			width: 18vw;
			height: 12vw;
			vertical-align: bottom;
			transition: all 0.3s;
		}

		&:hover{
			img{
				transform: scale(1.1, 1.1);
			}

			.yellow{
				background: darken(@_yellow, 15%);
			}

			.green{
				background: darken(@_green, 15%);
			}
		}
	}
	.choose_btn_txt{
		font-size: 35px;
		color: #fff;
		text-align: center;
		padding: 25px 0;
		transition: all 0.3s;
	}
	.yellow{
		background: @_yellow;
	}
	.green{
		background: @_green;
	}
	.choose_btn_img_wrap{
		overflow: hidden;
	}
	// 第二套皮肤
	.choose.skin_2{
		border: @border_width solid @green;
		background: @green;

		@circle_size: 300vw;

		.choose_bg{
			background: #fff;
			width: @circle_size;
			height: @circle_size;
			border-radius: 50%;
			margin-top: -257vw;
			margin-left: -102vw;
		}
		.change_skin_btn_txt{
			color: #fff;
		}
		.choose_btn_wrap{
			margin-top: 50px;
		}
		.choose_btn{
			box-shadow: 0 0 15px 15px rgba(0,0,0,0.03);
		}
		.choose_logo_txt{
			color: rgba(0,0,0,0.5);
			border-color: rgba(0,0,0,0.5);
		}
	}
	.choose_img_2_1{
		width: 23vw;
		height: 18vw;
	}
	.choose_img_2_2{
		width: 18vw;
		height: 18.7vw;
		margin-top: 21.4vw;
	}

	/* 手机端强制横屏 */
	@media screen and (orientation:portrait) {
		@border_width: 20px;
		body{
			background: #000;
		}
		.choose{
			border: @border_width solid #fff;
			height: 100vw;
			overflow: hidden;
			position: relative;
			margin-left: -2 * @border_width;

			// 强制横屏
			width: calc(100vh - 2 * @border_width);
			transform-origin: 0 0;
			transform: rotateZ(90deg) translateY(-100%);
		}
		@circle_size: 300vh;

		.choose_bg{
			background: @green;
			width: @circle_size;
			height: @circle_size;
			border-radius: 50%;
			margin-top: -264.5vh;
			margin-left: -102vh;
		}
		.choose_img_wrap{
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
			width: 100%;
		}
		.choose_img_1_1{
			width: 18vh;
			height: 25vh;
		}
		.choose_img_1_2{
			width: 14vh;
			height: 18vh;
			margin-top: 13.6vh;
		}
		.change_skin_btn{
			position: absolute;
			top: 0;
			right: 15%;
			width: 50px;
			height: 100px;
			cursor: pointer;
			z-index: 5;
			transition: all 0.3s;

			&:hover{
				img{
					opacity: 1;
					margin-top: -10px;
				}
			}
		}
		.choose_img_1_3{
			width: 35px;
			height: 70px;
			position: absolute;
			top: 0;
			left: 0;
		}
		.change_skin_btn_inner{
			position: relative;
		}
		.change_skin_btn_txt{
			position: absolute;
			color: @green;
			top: 0;
			left: 0;
			width: 35px;
			text-align: center;
			font-size: 16px;
			margin-top: 6px;
			font-weight: bold;
		}
		.choose_main{
			position: absolute;
			width: 100%;
			top: 0;
			left: 0;
			z-index: 2;
		}
		.choose_logo_wrap{
			text-align: center;
			margin-top: 6vh;
		}
		.logo_2{
			width: 30vh;
			display: block;
			margin: 0 auto;
		}
		.choose_logo_txt{
			border-top: 2px solid rgba(255,255,255,0.8);
			display: inline-block;
			padding-top: 10px;
			margin-top: 10px;
			color: rgba(255,255,255,0.5);
			font-size: 20px;
		}
		.choose_btn_wrap{
			width: 46%;
			margin: 4.7vh auto 0 auto;
		}

		@_yellow: #FCA733;
		@_green: #1CAAC4;

		.choose_btn{
			width: 18vh;
			border-radius: 15px;
			background: #fff;
			overflow: hidden;
			cursor: pointer;
			box-shadow: 0 0 15px 15px rgba(0,0,0,0.03);

			img{
				width: 18vh;
				height: 12vh;
				vertical-align: bottom;
				transition: all 0.3s;
			}

			&:hover{
				img{
					transform: scale(1.1, 1.1);
				}

				.yellow{
					background: darken(@_yellow, 15%);
				}

				.green{
					background: darken(@_green, 15%);
				}
			}
		}
		.choose_btn_txt{
			font-size: 20px;
			color: #fff;
			text-align: center;
			padding: 10px 0;
			transition: all 0.3s;
		}
		.yellow{
			background: @_yellow;
		}
		.green{
			background: @_green;
		}
		.choose_btn_img_wrap{
			overflow: hidden;
		}
		// 第二套皮肤
		.choose.skin_2{
			border: @border_width solid @green;
			background: @green;

			@circle_size: 300vh;

			.choose_bg{
				background: #fff;
				width: @circle_size;
				height: @circle_size;
				border-radius: 50%;
				margin-top: -257vh;
				margin-left: -102vh;
			}
			.change_skin_btn_txt{
				color: #fff;
			}
			.choose_btn_wrap{
				margin-top: 25px;
			}
			.choose_btn{
				box-shadow: 0 0 15px 15px rgba(0,0,0,0.03);
			}
			.choose_logo_txt{
				color: rgba(0,0,0,0.5);
				border-color: rgba(0,0,0,0.5);
			}
		}
		.choose_img_2_1{
			width: 23vh;
			height: 18vh;
		}
		.choose_img_2_2{
			width: 18vh;
			height: 18.7vh;
			margin-top: 21.5vh;
		}
		.version{
			bottom: 0;
			font-size: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/choose/choose.vue